<template>
<!-- <DashBoardLayout> -->
<div class="w100 ">
    <!-- <h2 class="cart-wizard-head">Choose Payment option</h2> -->
    <div class="cart-wrapper w100 form-control-wrapper">
        <div class="payment-options">
            <input type="radio" @click="onPaymentChange('Online Payment')" name="payment_method" value="Online Payment" id="upi" class="payment_mode with-gap validate[required],gender" />
            <label for="upi" class="">
                <div class="row align-items-center">
                    <img src="../../assets/images/upi_payments.gif" class="upi_img"/>Online Payment</div>
            </label>
        </div>
        <div class="payment-options">
            <input type="radio" @click="onPaymentChange('COD')" name="payment_method" value="COD" id="cod" class="payment_mode with-gap" />
            <label for="cod" class="">Cash On Delivery (COD)</label>
        </div>
    </div>
</div>
<!-- </DashBoardLayout> -->
</template>

<script>
export default {
    name: 'Payments_tab',
    data() {
        return {
            payment_mode: 'COD',
        }
    },
    methods: {
        onPaymentChange(a) {
            this.payment_mode = a
            this.$emit('onPaymentChange', this.payment_mode)
        },
        // loadData: function () {
        //     localStorage.setItem("customer_id", "1")
        //     this.customer_id = localStorage.getItem("customer_id")
        //     var addressURL = this.baseUrl + this.addressUrl + "?token=" + this.token + "&customer_id=1"
        //     console.log("address url : " + addressURL)
        //     axios.get(addressURL)
        //         .then((response) => {
        //             // alert(response)
        //             this.addressList = response.data;
        //             if (this.addressList.length == 0) {
        //                 this.addFlag = true
        //             } else {
        //                 this.addFlag = false
        //             }
        //             this.addressmobile = localStorage.mobile;
        //             console.log("cust id =" + this.customer_id);
        //             console.log(this.addressList);
        //             this.selecetdAddress = this.addressList[0].address_id
        //         });

        // },

    },
}
</script>
